import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, effect, signal } from '@angular/core';
import { Observable } from 'rxjs';

export type CheckBoxMultipleItem = {
  label: string,
  id: string,
  name: string,
  selected : boolean
}

export const createCheckBoxMultipleItem = (names: string[])  => names.map( (name , i) => ({
  name,
  label: name,
  selected: false,
  id: `${name}-${i}`
}))

@Component({
  selector: 'app-checkbox-multiple-buttons',
  templateUrl: './checkbox-multiple-buttons.component.html',
  styleUrls: ['./checkbox-multiple-buttons.component.scss']
})
export class CheckboxMultipleButtonsComponent implements OnChanges,  OnInit {


  @Input() items : CheckBoxMultipleItem[] = []
  @Input() resetOnDisable = true;
  @Input() id : string = '';
  @Input() disabled = false;
  @Output() check = new EventEmitter<CheckBoxMultipleItem>()
  @Input() size? : 'md' | 'auto' | 'sml' | 'big';
  @Input() grid = false;
  @Input() checkedItems : string[] = [];

  @Input() manualCheck?: Observable<string>;


  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.items.forEach( item => {
    //   // console.log({item})
    // } )
    }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.resetOnDisable) {
      this.items.forEach( item => {
        item.selected = false;
      })
    }
    if (changes['checkedItems']) {
      this.items.forEach( item => {
       item.selected =  this.checkedItems.map( i => i.trim()).includes(item.name.trim())
      })
    }
  }

  itemChange(value: boolean , item: CheckBoxMultipleItem) {
    // por algum motivo as vezes recebe value como string, repetindo emits
    item.selected = value;
    // console.log({value , item})
    if (value === !!value) {
      // item.selected = !item.selected;
      // this.value

      this.check.emit(item)
    }
  }

}
